import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_RC_360_MESSAGE_SERVER_URL,
  headers: {
    Accept: "application/json",
  },
});
